//Info about user journeys and achieved milestones (Keep in mind that this is not persistant across sessions)
import { defineStore } from 'pinia';

export const useJourneyStore = defineStore('journeyStore', {
  state: () => {
    return {
      completedUserJourneys: {
        //Achieved user journeys. Can be used as triggers for events (like showing pwa install prompt) etc.
        viewedTrialAndReturnedToList: false, //User viewed trial details and returned to trial list
      },
      mileStones: {
        visitedDetails: false,
        visitedList: false,
      },
    };
  },
  getters: {},
});
